export const removeAtIndex = <T>(array: T[], index: number): T[] => [...array.slice(0, index), ...array.slice(index + 1)]

export const insert = <T>(array: T[], index: number, ...newItems: T[]): T[] => [...array.slice(0, index), ...newItems, ...array.slice(index)]
